module.exports = __webpack_public_path__ + "static/media/slack.c1e05eae.png";